import gql from 'graphql-tag';

const RESTORE = gql`
mutation restoreBackup($url: String, $name: String){
  restoreBackup(url: $url, name: $name)
}
`;
export default RESTORE 